import { call, put, takeLatest } from 'redux-saga/effects'
import { TenantActions, TenantTypes } from './tenantSlice'
import api from '../../services/api'

function* createTenantSaga(action) {
  const { listingId, data } = action
  const response = yield call(api.createTenant, listingId, data)

  if (response.ok) {
    yield put(TenantActions.createTenantSuccess(response.data))
  } else {
    const errorMsg = response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem
    yield put(TenantActions.createTenantFailure(errorMsg))
  }
}

export default function* tenantSaga() {
  yield takeLatest(TenantTypes.CREATE_TENANT_REQUEST, createTenantSaga)
}